<template>
  <v-tooltip right content-class="tooltip" max-width="400px">
    <template v-slot:activator="{ on }">
      <v-icon v-on="on" class="mr-5"> mdi-help-circle-outline </v-icon>
    </template>
    {{ $t('search.instruction.moduleFilter') }}
  </v-tooltip>
</template>
<script>
export default {
  name: 'ModuleFilterInfo',
};
</script>
<style scoped>
.tooltip {
  opacity: 1 !important;
  background: #202020;
  white-space: pre-line;
  padding: 10px;
}
</style>
